export const orderReport = {
	title: "Informe de pedidos",
	sheet: {
		filename: "vendor-delivery-report",
		title: "Ventas Delivery",
		columns: {
			chanel: "Plataforma",
			reference: "N° del pedido",
			date: "Fecha y hora",
			obs: "OBS",
			status: "Estado",
			paymentMethods: "Métodos de pago",
			customerName: "Cliente",
			customerPhone: "Teléfono Cliente",
			vendor: "Vendor",
			value: "Valor",
			deliveryFee: "Tarifa de entrega",
			tip: "Propina",
			discount: "Descuento",
			subtotal: "Subtotal",
		},
	},
	columns: {
		chanel: "Plataforma",
		reference: "N° del pedido",
		date: "Fecha y hora",
		obs: "OBS",
		status: "Estado",
		paymentMethods: "Métodos de pago",
		customerName: "Cliente",
		customerPhone: "Teléfono Cliente",
		vendor: "Vendor",
		value: "Valor",
		deliveryFee: "Tarifa de entrega",
		tip: "Propina",
		discount: "Descuento",
		subtotal: "Subtotal",
	},
	vendorLabels: {
		coala: "Whitelabel",
		ifood: "Ifood",
		rappi: "Rappi",
		ubereats: "Uber Eats",
	},
	methodsLabel: {
		creditCard: "Tarjeta de crédito",
		debitCard: "Tarjeta de débito",
		cash: "Efectivo",
		creditCardOnline: "Tarjeta de crédito en línea",
		voucherInPlace: "Voucher",
		mastercard: "Master-card",
		visa: "Visa",
		amex: "Amex",
		elo: "Elo",
		hipercard: "Hiper-card",
		diners: "Diners",
		ticket: "Ticket",
		alelo: "Alelo",
		vr: "VR",
		ben: "Ben",
		sodexo: "Sodexo",
		pix: "Pix",
	},
	statusLabel: {
		ready: "Listo",
		canceled: "Cancelado",
		concluded: "Concluido",
		confirmed: "Confirmado",
		dispatched: "Despachado",
		integrated: "Integrado",
		placed: "Creado",
		pendingPayment: "Pago pendiente",
		pickupAreAssigned: "Cliente en el local",
		scheduled: "Programado",
	},
	channelLabel: {
		marketplace: "Marketplace",
		phone: "Teléfono",
		whatsapp: "Whatsapp",
		whitelabel: "Whitelabel",
	},
};
